import React, { Component } from 'react';
import ls from 'localstorage-slim';
import './Login.css';

export class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: "",
        };
    }

    login_OnClick() {
        //let url = "https://localhost:44352/OviewProxy?https://ntmap.nantou.gov.tw/server/users/login";
        let url = `${window.location.pathname}/server/users/login`;
        var CryptoJS = require("crypto-js");
        const key = CryptoJS.enc.Base64.parse("Pi10tGAeANTYxYzlmZTA2OA==");
        const iv = CryptoJS.enc.Base64.parse("Pi10tGAeANTYxYzlmZTA2OA==");

        let result = CryptoJS.AES.encrypt(this.state.password, key, {
            iv,
            moode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const data = {
            username: this.state.username,
            password: result.toString()
        };

        fetch(url, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }).then((response) => {
            return response.json();
        }).then(function (json) {
            if (json.success) {
                ls.set("userInfo", json.ret, { ttl: 86400, encrypt: true });
                this.props.login();
            }
        }.bind(this)).catch((error) => {
            console.log(`Error: ${error}`);
        })
    }

    render() {
        return (
            <div className="login">
                <div className="instructions-row">
                    <span>帳號:</span>
                    <input type="text" value={this.state.username} onChange={(e) => { this.setState({ username: e.target.value }); }} />
                </div>
                <div className="instructions-row">
                    <span>密碼:</span>
                    <input type="password" value={this.state.password} onChange={(e) => { this.setState({ password: e.target.value }); }} />
                </div>
                <div className="instructions-row">
                    <button onClick={() => { this.login_OnClick() }}>登入</button>
                </div>
            </div>
        );
    }
}